// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.sa-feedback-block .sa-horizontal-line {
  height: 1px;
  background: #F2F4F7;
}
.sa-feedback-block .sa-feedback-row {
  margin-top: 10px;
  display: flex;
  justify-content: space-between;
}
.sa-feedback-block .sa-feedback-row .sa-left {
  font-weight: 400;
  font-size: 11px;
  line-height: 14px;
  color: #98A2B3;
}
.sa-feedback-block .sa-feedback-row .sa-right {
  display: flex;
  gap: 4px;
  cursor: pointer !important;
}
.sa-feedback-block .sa-comments-block {
  font-size: 12px;
  font-weight: 500;
  line-height: 16px;
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
}
.sa-feedback-block .sa-comments-block .sa-comment {
  border: 1px solid #F9FAFB;
  background: #EAECF0;
  color: #344054;
  padding: 2px 8px;
  border-radius: 25px;
  cursor: pointer;
}
.sa-feedback-block .sa-comments-block .sa-comment.sa-active {
  border: 1px solid #B2CCFF;
  color: #155EEF;
}`, "",{"version":3,"sources":["webpack://./src/plugins/answers/templates/feedbackTemplate/feedbackTemplate.scss"],"names":[],"mappings":"AACI;EACI,WAAA;EACA,mBAAA;AAAR;AAGI;EACI,gBAAA;EACA,aAAA;EACA,8BAAA;AADR;AAGQ;EACI,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;AADZ;AAKQ;EACI,aAAA;EACA,QAAA;EACA,0BAAA;AAHZ;AAOI;EACI,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,aAAA;EACA,eAAA;EACA,SAAA;AALR;AAOQ;EACI,yBAAA;EACA,mBAAA;EACA,cAAA;EACA,gBAAA;EACA,mBAAA;EACA,eAAA;AALZ;AAOY;EACI,yBAAA;EACA,cAAA;AALhB","sourcesContent":[".sa-feedback-block {\n    .sa-horizontal-line {\n        height: 1px;\n        background: #F2F4F7;\n    }\n\n    .sa-feedback-row {\n        margin-top: 10px;\n        display: flex;\n        justify-content: space-between;\n\n        .sa-left {\n            font-weight: 400;\n            font-size: 11px;\n            line-height: 14px;\n            color: #98A2B3;\n        }\n        \n\n        .sa-right {\n            display: flex;\n            gap: 4px;\n            cursor: pointer !important;\n        }\n    }\n\n    .sa-comments-block {\n        font-size: 12px;\n        font-weight: 500;\n        line-height: 16px;\n        display: flex;\n        flex-wrap: wrap;\n        gap: 10px;\n\n        .sa-comment {\n            border: 1px solid #F9FAFB;\n            background: #EAECF0;\n            color: #344054;\n            padding: 2px 8px;\n            border-radius: 25px;\n            cursor: pointer;\n\n            &.sa-active {\n                border: 1px solid #B2CCFF;\n                color: #155EEF;\n            }\n        }\n    }\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
